    <div class="card-box clearfix">
        {{each OnlyOneData item i}}     
            <div class="card-module">
                <a href="/home.html?userid={{item.UserID}}" target="_blank">
                    <div class="pic">
                        <div class="snum">
                        {{if item.RoleID===1}} 
                        普通用户
                        {{else if item.RoleID===2}}
                            {{if item.UserLevel===1}} 
                                1星咨询师
                            {{else if item.UserLevel===2}} 
                                2星咨询师
                            {{else if item.UserLevel===3}} 
                                3星咨询师
                            {{else if item.UserLevel===4}} 
                                4星咨询师
                            {{else if item.UserLevel===5}} 
                                5星咨询师                               
                            {{/if}}
                        {{else if item.RoleID===3}}
                        社工志愿者
                        {{else if item.RoleID===4}}
                        专家
                        {{else if item.RoleID===7}}
                        特约咨询师
                         {{/if}}
                        </div>
                        <div class="mask" style="background-image:url('{{item.DataUrl}}')"></div>
                        {{if item.CallStatus===2}}
                        <!--放电中-->
                            <label class="callStatus">
                                <img src="../../public/images/callStatus_wink.png">
                            </label>
                        {{/if}}
                    </div>
                </a>
                <div class="info">
                    <div class="headline clearfix">
                        <h2>{{item.NickName}}</h2>
                        {{if item.Sex=='1'}}
                            <span class="malebg">
                                <i class="iconfont icon-nanxing"></i><label class="">{{item.Age}}</label>
                            </span>
                        {{else if item.Sex=='2'}}
                            <span class="femalebg">
                                <i class="iconfont icon-nvxing"></i><label class="">{{item.Age}}</label>
                            </span>
                        {{/if}}
                        {{if item.IsVip}}
                            <span class="vip">
                                <img src="../../public/images/vip.png">
                            </span>
                        {{/if}}
                    </div>
                    <div class='footline'>
                        {{if item.MediaLength > 0}} 
                            <div class="voice-box" data-media={{item.MediaUrl}} data-time={{item.MediaLength}} onclick="playVoice(this)">
                                <div class="rhythm_box">
                                    <span class="line2"></span>
                                    <span class="line3"></span>
                                    <span class="line4"></span>
                                </div>
                                <div class="pause_rhythm">
                                    <span class="line2"></span>
                                    <span class="line3"></span>
                                    <span class="line4"></span>
                                </div>
                                <label class="fr timeL" data-ctime={{item.MediaLength}}>{{item.transMediaLength}}</label>
                            </div>
                        {{else}}
                            <div class="mytip">{{item.MyTips}}</div>
                        {{/if}}
                    </div>
                </div>
            </div>
        {{/each}}
    </div>
